import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { serviceSharedFiles } from "./serviceSharedFiles";

export const submitSharedFile = async (sharedFileId: string) => {
  const { data } = await serviceSharedFiles.post<ISharedFileRequestResponse>(
    `/request/${sharedFileId}/submit`
  );

  return data;
};
